import { PushApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { KEY } from './keys';
import { getQueryKeys } from 'queries/query-key';

function useSend() {
  const queryClient = useQueryClient();
  return useAuthMutation(PushApi.send, {
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).details(),
      });
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).lists(),
      });
    },
  });
}

export default useSend;
